import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import CreateEditUserForm from "./CreateEditUserForm";
import useGetUserRoles from "../../../hooks/masters/users/useGetUserRoles";
import useCreateEditUser from "../../../hooks/masters/users/useCreateEditUser";
import Spinner from "../../../components/spinner";

const EditUser = () => {
  const navigate = useNavigate();
  const { userId } = useParams(); // Assuming userId is passed in the URL params

  const { userRoles } = useGetUserRoles();

  const userRolesOptions = userRoles?.map?.((role) => ({
    value: role.name,
    label: role.description,
  }));

  const {
    updateUser,
    register,
    handleSubmit,
    errors,
    watch,
    isEditDataLoading,
    control,
    getValues,
    setValue,
  } = useCreateEditUser({ isEdit: true, userId: userId }); // Pass the userId if available

  return (
    <div className="container_xxl relative z-10 px-4">
      <div className="flex items-center space-x-4 headingBorder__b">
        <div>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        </div>
        <div>
          <h1 className="heading">Edit User</h1>
        </div>
      </div>

      {isEditDataLoading ? (
        <div className="flex justify-center items-center py-16">
          <div>
            <Spinner />
          </div>
          <p>Loading data...</p>
        </div>
      ) : (
        <CreateEditUserForm
          isEdit={true}
          register={register}
          handleSubmit={handleSubmit}
          errors={errors}
          onSubmit={updateUser}
          watch={watch}
          control={control}
          getValues={getValues}
          setValue={setValue}
          userRolesOptions={userRolesOptions}
        />
      )}
    </div>
  );
};

export default EditUser;
